/**
 * @author Ariel
 * @description 公共配置新增编辑页面
 * @Date 2020/1/2
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool,utils_tool } from '@/tool'
let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizForm, WizSpin } = component_tool;
let { Session } = utils_tool

class commonConfigDetail extends WizContainer {

  componentName = 'commonConfigDetail';

  constructor(props) {
    super(props);
    const { history } = props;
    let initialValue = {};
    let positionState = 1;
    let cardTitle = '新增'
    if (history.location && history.location.pathname === '/common/commonConfig/commonConfigUpd') {
      if(history.location && history.location.record){
        initialValue = history.location.record;
        positionState = initialValue.state;
        Session.set('positionDetailUpd',initialValue)
        Session.set('positionState',positionState)
      }else{
        initialValue = Session.get('positionDetailUpd') || {};
        positionState = Session.get('positionState') || 1;
      }
      cardTitle = '编辑'
    }
    this.state = {
      cardTitle,
      name: null
    }
    this.positionState = positionState;
    this.initialValue = initialValue;
  }

  propsAndStateOnChange = {
    addCommonConfig: this._addCommonConfigOver.bind(this)
    // positionCategoryList: this.positionCategoryListOnChange.bind(this)
  }

  // positionCategoryListOnChange(nextProps, nextState) {
  //   let _list = [];
  //   if (nextProps['positionCategoryList'] && nextProps['positionCategoryList']['success'] === true) {
  //     let list = nextProps["positionCategoryList"]['data']
  //     list && list.forEach(val => {
  //       _list.push({ code: val['id'], codeName: val['name'] })
  //     });
  //     nextState['positionCategoryList'] = _list;
  //     return true;
  //   } else {
  //     wizNotice.error(_nextProps["positionCategoryList"]['msg'])
  //     return false;
  //   }
  // }

  /**
   * 岗位变动成功返回原页面，失败弹出提示
   */
  _addCommonConfigOver(nextProps, nextState) {
    if (nextProps.addCommonConfig.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/common/commonConfig');
    } else {
      wizNotice.error('提交失败：' + nextProps.addCommonConfig.msg);
      log.error('岗位提交失败：' + nextProps.addCommonConfig.msg);
    }
    return true;
  }

  /**
   * 保存/更新 公共配置信息
   * @param values
   * @private
   */
  _savePosition(values) {
    const { history } = this.props;
    let apiPath = "commonConfig/add";
    if (history.location && history.location.pathname === '/common/commonConfig/commonConfigUpd') {
      apiPath = "commonConfig/update"
    }
    let fitterFieldsValue={"configInfo":values}
    this.doAction({
      path: apiPath,
      payload: {
        key: "addCommonConfig",
        apiParams: {
          ...fitterFieldsValue
        }
      }
    });
  }




  _render() {
    const { positionCategoryLoading } = this.props;
    let { cardTitle, positionCategoryList } = this.state;
      let columns = [
            {
              formItem: {
                type: "hidden",
                initialValue: this.initialValue.id
              },
              name: "id"
            },
            {
              title: "配置key",
              name: "configKey",
              formItem: {
                maxlength: 20,
                placeholder: '配置key最多输入20个字',
                rules: [
                  {
                    required: true,
                    message: '请输入配置key'
                  },
                  {
                    pattern: /^[^\s]*$/,
                    message: '配置key录入信息不能包含空格'
                  }
                ],
                initialValue: this.initialValue.configKey
              }
            },
            {
              title: "配置内容",
              name: "configValue",
              formItem: {
                rules: [
                  {
                    required: true,
                    message: '请输入配置内容'
                  },
                  {
                    pattern: /^[^\s]*$/,
                    message: '配置内容录入信息不能包含空格'
                  }
                ],
                initialValue: this.initialValue.configValue
              }
            },
            {
            title: "备注",
            name: "remarks",
            formItem: {
              rules: [
                {
                  required: true,
                  message: '请输入备注'
                },
                {
                  pattern: /^[^\s]*$/,
                  message: '备注录入信息不能包含空格'
                }
              ],
              initialValue: this.initialValue.remarks
            }
          },
           
          ]

    let onSubmit = this._savePosition.bind(this);

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }

    return (
      <WizCard>
      <WizSpin tip={'加载中'} spinning={positionCategoryLoading}>
        <WizForm className={'form-inline'} {...formProps} />
      </WizSpin>
    </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {commonConfig} = state;
  const addCommonConfig = modelUtils.getModelEntity(commonConfig, "addCommonConfig");
  const load = modelUtils.getLoadingState(state, 'positionCategory');
  return {
    addCommonConfig : addCommonConfig,
    ...load
  }
};

export default connect(mapStateToProps)(commonConfigDetail);
















